import React from 'react'
import { Separator, Skeleton } from '@fs/zion-ui'

export default function LifeSketchSkeleton(): JSX.Element {
  return (
    <>
      <Skeleton.Paragraph lineCount={2} size="md" />
      <Separator size="nano" />
    </>
  )
}
